import React, { useEffect, useState } from 'react';

import { HomeIcon } from 'lucide-react';
import { Link, matchPath, useLocation } from 'react-router-dom';

import { routesBreadcrumbConfig } from '../../../router/breadcrumb-config.js';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '../../ui/breadcrumb';

export function Breadcrumbs() {
  const location = useLocation();
  const [crumbs, setCrumbs] = useState([]);

  useEffect(() => {
    const segments = location.pathname.split('/').filter(Boolean);

    async function buildCrumbs() {
      const result = [];

      for (let idx = 0; idx < segments.length; idx++) {
        const path = '/' + segments.slice(0, idx + 1).join('/');

        const matchConfig = routesBreadcrumbConfig.find((route) =>
          matchPath({ path: route.path, end: true }, path),
        );

        if (matchConfig) {
          let label;

          if (typeof matchConfig.breadcrumb === 'function') {
            const params = matchPath(
              { path: matchConfig.path, end: true },
              path,
            )?.params;

            const maybeAsync = matchConfig.breadcrumb(params);
            label =
              maybeAsync instanceof Promise ? await maybeAsync : maybeAsync;
          } else {
            label = matchConfig.breadcrumb;
          }

          result.push({ label, path });
        }
      }

      setCrumbs(result);
    }

    buildCrumbs();
  }, [location.pathname]);

  if (location.pathname === '/backoffice') {
    return null;
  }

  return (
    <Breadcrumb className="pb-4">
      <BreadcrumbList>
        {/* Always show /backoffice as home */}
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to="/backoffice">
              <HomeIcon className="size-4" />
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>

        {crumbs.map((crumb, idx) => (
          <React.Fragment key={crumb.path}>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              {idx === crumbs.length - 1 ? (
                <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink asChild>
                  <Link to={crumb.path}>{crumb.label}</Link>
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
          </React.Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
